<template>
  <div
    class="breadcrumbs"
    id="BreadCrumbs"
    v-if="!['Login'].includes($route.name)">
    <ul>
      <li v-for="item in showingRouts" :key="item.name">
        <span
          v-if="item.isChild">
          {{item.name}}
        </span>
        <span
          v-else-if="item.components.default.name === 'Inner'">
          {{L10n(item.meta.label || item.name)}}
        </span>
        <router-link
          v-else
          :to="{name: item.name}">
          {{L10n(item.meta.label || item.name)}}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  watch: {
    '$route': {
      immediate: true,
      handler () {
        let patterns = [
          {
            pattern: /edit\[.+?\]/g,
            patternGetValue: /\d+/g
          }
        ]
        let query = this.$route.query
        let results = []
        for (let key in query) {
          let str = String(query[key])
          results = results.concat(patterns.reduce((accum, patternConf) => {
            let { pattern, patternGetValue } = patternConf
            let matches = str.match(pattern) || []
            matches = matches.map((match) => {
              let values = match.match(patternGetValue) || []
              return values.join('')
            })
            return (accum = accum.concat(matches))
          }, []))
        }
        this.childRoutes = results.reduce((accum, value, i) => {
          if (value) {
            accum.push(Object.assign(this.getChildModel(), { name: value, id: i }))
          }
          return accum
        }, [])
      }
    }
  },
  data () {
    return {
      childRoutes: []
    }
  },
  computed: {
    routes () {
      return this.$route.matched.filter(value => value.name !== 'Dashboard')
    },
    showingRouts () {
      return this.routes.concat(this.childRoutes)
    }
  },
  methods: {
    getChildModel () {
      return {
        id: null,
        name: null,
        isChild: true
      }
    },
    handleBack () {
      this.$store.getters.get('routeFrom').splice(-1, 1)
      this.$router.back()
    }
  }
}
</script>

<style lang="stylus">
  .breadcrumbs {
    display flex
    align-items center
    margin 0
    ul {
      margin 0
      padding 0
      list-style none
      line-height 1.8rem
      display flex
      flex-wrap wrap
      li {
        font-size 1.3rem
        color #bcbbbe
        text-transform capitalize
        position relative
        padding 0 0.9rem 0 0
        margin 0 0.5rem 0 0
        a {
          color #bcbbbe
          text-decoration none
          &:hover {
            text-decoration underline
          }
        }
        &:before {
          content '/'
          position absolute
          top 0
          right 0
        }
        &:last-child {
          padding-right 0
          margin-right 0
          &:before {
            display none
          }
        }
      }
    }
    .btn.btn-link.btn-back {
      text-transform capitalize
      font-size 1.7rem
      line-height 1.8rem
      color #36587A
      background #fafafa
      border-radius .5rem
      margin 0 1rem 0 0
      i {
        font-size 1.4rem
        line-height 1.8rem
        padding 0 .5rem
        vertical-align top
        transition transform .22s ease-in-out
        transform translateX(0)
      }
      &:hover,
      &:focus,
      &:active {
        background #eeeeee
        i {
          transform translateX(-.3rem)
        }
      }
    }
  }
</style>
